<template>
  <div class="testeDiv">
    <DialogPlanoCliente ref="dialogPlanoCliente" @fechar="carregarItens()" />
    <div class="row">
      <div class="col col-md-12 col-sm-12 text-center">
        <div
          class="d-flex justify-content-center"
          v-bind:style="{ display: propView == 'completo' ? 'block' : 'none' }"
        >
          <Combo
            :itens="$global.sites_filtro_completo()"
            v-model="filtroSite"
            style="max-width: 150px; margin-right: 10px; display: none"
            v-if="
              retornaSite() !== 'Share' &&
              retornaSite() !== 'Stream1x2' &&
              retornaSite() !== '7live'
            "
          />

          <div style="margin-right: 10px" v-if="propView == 'completo'">
            <button
              type="button"
              class="btn btn-sm btn-light"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <small>Tipo<br /></small>
              <small>{{
                filtroTipo == "TODOS"
                  ? "Todos"
                  : filtroTipo == "EMAIL_PIX"
                  ? "Pix"
                  : "Paypal"
              }}</small>
            </button>
            <div class="dropdown-menu">
              <span
                class="dropdown-item"
                style="cursor: pointer"
                @click="
                  filtroTipo = 'TODOS';
                  carregarItens();
                "
                >Todos</span
              >
              <span
                class="dropdown-item"
                style="cursor: pointer"
                @click="
                  filtroTipo = 'EMAIL_PIX';
                  carregarItens();
                "
                >Pix</span
              >
              <span
                class="dropdown-item"
                style="cursor: pointer"
                @click="
                  filtroTipo = 'PAYPAL';
                  carregarItens();
                "
                >Paypal</span
              >
            </div>
          </div>

          <div style="margin-right: 10px" v-if="propView == 'completo'">
            <button
              type="button"
              class="btn btn-sm btn-light"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <small>Status<br /></small>
              <small>{{
                filtroStatus == "TODOS"
                  ? "Todos"
                  : filtroStatus == "NOVO"
                  ? "Novos"
                  : "Criados"
              }}</small>
            </button>
            <div class="dropdown-menu">
              <span
                class="dropdown-item"
                style="cursor: pointer"
                @click="
                  filtroStatus = 'TODOS';
                  carregarItens();
                "
                >Todos</span
              >
              <span
                class="dropdown-item"
                style="cursor: pointer"
                @click="
                  filtroStatus = 'NOVO';
                  carregarItens();
                "
                >Novos</span
              >
              <span
                class="dropdown-item"
                style="cursor: pointer"
                @click="
                  filtroStatus = 'CRIADO';
                  carregarItens();
                "
                >Criados</span
              >
            </div>
          </div>

          <DataFiltro
            :value="filtroData"
            @change="carregarItens()"
            v-bind:style="{
              display: propView == 'completo' ? 'block' : 'none',
            }"
            @reload="carregarItens()"
            :propEnabledExportar="true"
            @export="exportItens()"
          />
        </div>

        <div class="d-flex justify-content-center mt-2">
          <input
            class="form-control inputPesquisa"
            style="max-width: 50%; margin-right: 10px"
            type="text"
            placeholder="CPF, NOME..."
            v-model="filtroTexto"
            @keyup="keyupFiltroTexto"
          />
        </div>

        <hr
          v-bind:style="{ display: propView == 'completo' ? 'block' : 'none' }"
        />

        <div class="row" v-if="false && retornaSite() == 'Weddbets'">
          <div class="col col-md-1"></div>
          <div
            class="col col-md-5"
            v-for="(headerSite, headerSiteKey) in headerSites"
            :key="headerSiteKey"
            :item="headerSite"
          >
            <ListCardsProgress :itens="headerSite" />
          </div>
        </div>

        <div class="rowLista">
          <div
            class="list-group-item"
            v-for="item in itens"
            :key="item.key"
            :item="item"
          >
            <ListPayAdminItem
              :item="item"
              @lancarPlanoCliente="lancarPlanoCliente(item)"
            />
          </div>
        </div>

        <p
          v-bind:style="{ display: propView == 'completo' ? 'block' : 'none' }"
          style="margin-top: 15px"
        >
          Total de {{ itens.length }} itens
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";

import util from "../includes/util.js";

import Combo from "../components/Combo.vue";
import DataFiltro from "../components/DataFiltro.vue";
import ListCardsProgress from "../components/ListCardsProgress.vue";
import DialogPlanoCliente from "../dialogs/DialogPlanoCliente.vue";
import ListPayAdminItem from "./ListPayAdminItem.vue";

export default {
  name: "ListPlanosCliente",
  components: {
    Combo,
    DataFiltro,
    ListCardsProgress,
    DialogPlanoCliente,
    ListPayAdminItem,
  },
  props: {
    itensLimit: { type: Number, default: 50 },
    propUsuario: { type: String, default: "" },
    propView: { type: String, default: "usuario" },
  },
  methods: {
    limpar() {
      this.$set(this.item, "plano", "");
      this.itens = [];
      this.planos = [];
    },
    retornaSite() {
      return this.$site;
    },
    async carregarItensUsuario(idUsuario) {
      const responsePlano = await api.get("/pp?idUsuario=" + idUsuario);
      api.valid(responsePlano.data, this.$router);

      if (!responsePlano.data.erro) {
        this.itens = responsePlano.data.itens;
      }
    },
    async carregarItens() {
      const responsePlano = await api.get(
        "/pp?data=" +
          this.filtroData.dia +
          "-" +
          this.filtroData.mes +
          "-" +
          this.filtroData.ano +
          (this.filtroTipo !== "TODOS" ? "&tipo=" + this.filtroTipo : "") +
          (this.filtroStatus !== "TODOS"
            ? "&status=" + this.filtroStatus
            : "") +
          (this.filtroTexto !== "" ? "&_all=" + this.filtroTexto : "")
      );
      api.valid(responsePlano.data, this.$router);

      if (!responsePlano.data.erro) {
        this.itens = responsePlano.data.itens;

        if (
          false == true &&
          this.retornaSite() == "Weddbets" &&
          this.propView == "completo"
        ) {
          var headerSites = {};

          //* Registra o total de planos por sites
          this.itens.forEach((element) => {
            if (!headerSites[element.plano.site]) {
              headerSites[element.plano.site] = {
                nome: element.plano.site,
                quantidade: 0,
                planos: [],
              };
            }

            if (!headerSites[element.plano.site].planos[element.plano.nome]) {
              headerSites[element.plano.site].planos[element.plano.nome] = {
                nome: element.plano.nome,
                quantidade: 0,
              };
            }

            headerSites[element.plano.site].quantidade =
              headerSites[element.plano.site].quantidade + 1;
            headerSites[element.plano.site].planos[
              element.plano.nome
            ].quantidade =
              headerSites[element.plano.site].planos[element.plano.nome]
                .quantidade + 1;
          });

          var headerSitesTotal = 0;

          //* Percorre os sites para calcular os totais e ordenar os planos
          for (const headerSiteKey in headerSites) {
            headerSitesTotal =
              headerSitesTotal + headerSites[headerSiteKey].quantidade;
            headerSites[headerSiteKey].planos = Object.values(
              headerSites[headerSiteKey].planos
            ).sort((a, b) => b.quantidade - a.quantidade);
          }

          this.headerSites = {};

          //* Insere os sites no elemento de cards
          for (const headerSiteKey in headerSites) {
            this.headerSites[headerSiteKey] = [];

            //* Insere o card do site
            this.headerSites[headerSiteKey].push({
              cor: "bg-success",
              titulo: headerSites[headerSiteKey].nome,
              subtitulo:
                "Planos " +
                headerSites[headerSiteKey].quantidade +
                " de " +
                headerSitesTotal,
              valor: headerSites[headerSiteKey].quantidade,
              total: headerSitesTotal,
            });

            //* Insere o card de cada plano
            for (const headerPlanoKey in headerSites[headerSiteKey].planos) {
              this.headerSites[headerSiteKey].push({
                cor: "bg-warning",
                titulo: headerSites[headerSiteKey].planos[headerPlanoKey].nome,
                subtitulo:
                  "Planos " +
                  headerSites[headerSiteKey].planos[headerPlanoKey].quantidade +
                  " de " +
                  headerSites[headerSiteKey].quantidade,
                valor:
                  headerSites[headerSiteKey].planos[headerPlanoKey].quantidade,
                total: headerSites[headerSiteKey].quantidade,
              });
            }
          }
        }
      }
    },
    editarItem(id) {
      this.$refs.editItem.carregarItem(id);
    },
    itemNovo() {
      this.$refs.editItem.novo();
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
    formatDateTime(data) {
      return util.formatDateTime(data);
    },

    async excluir(item) {
      if (confirm("Deseja excluir o item ?")) {
        const responsePlano = await api.post("/plano/usuario/excluir", {
          usuario: item.usuario._id,
          key: item.key,
        });
        api.valid(responsePlano.data, this.$router);

        if (!responsePlano.data.erro) {
          if (this.propView == "usuario") {
            this.carregarItensUsuario(item.usuario._id);
            this.$emit("item-excluido");
          } else {
            this.carregarItens();
          }
        }
      }
    },
    keyupFiltroTexto() {
      clearTimeout(this.timerFiltroTexto);

      var obj = this;

      this.timerFiltroTexto = setTimeout(function () {
        obj.carregarItens();
      }, 1000);
    },
    lancarPlanoCliente(item) {
      //this.$refs.dialog.fechar();
      this.$refs.dialogPlanoCliente.payItem = item;
      this.$refs.dialogPlanoCliente.abrir();
    },
    fecharPlanoCliente() {
      //this.$refs.listPlanosCliente.carregarItensUsuario(this.item._id);
      //this.calcularVencimento(null);
      //this.$refs.dialog.abrir();
    },
    exportItens() {
      var conteudo =
        "pay data\tpay status\tpay nome\tpay tipo\tpay valor\tpay chave\tpay chave\tsite\tdata\temail\tplano\tdias\tinicio\tfim\tcomprovante\tlancamento\n";

      for (var indiceItem = 0; indiceItem < this.itens.length; indiceItem++) {
        var item = this.itens[indiceItem];
        conteudo += 
          this.formatDateTime(item.data) + "\t" +
          item.status +
          "\t" +
          item.regexNome +
          "\t" +
          (item.tipo == "EMAIL_PIX" ? "PIX" : "") +
          "\t" +
          item.regexValor +
          "\t" +
          item.regexTipo +
          "\t" +
          (item.regexTipo == "CNPJ" ? item.regexCnpj : item.regexCpf) +
          "\t";

          if(item.planoUsuario && item.planoUsuario !== null && item.planoUsuario._id){
            conteudo +=
              item.planoUsuario.plano.site +
              "\t" +
              this.formatDateTime(item.planoUsuario.dataLancamento) +
              "\t" +
              item.planoUsuario.usuario.email +
              "\t" +
              item.planoUsuario.plano.nome +
              "\t" +
              item.planoUsuario.plano.duracao +
              "\t" +
              this.formatDate(item.planoUsuario.dataInicio) +
              "\t" +
              this.formatDate(item.planoUsuario.dataFim) +
              "\t" +
              (item.planoUsuario.comprovante ? item.planoUsuario.comprovante : "") +
              "\t" +
              (item.planoUsuario.usuarioCriacao
                ? item.planoUsuario.usuarioCriacao.nome
                : "");
          }

          conteudo += "\n";
        
      }

      this.$copyText(conteudo).then(
        function (e) {
          alert("Copiado com sucesso!");
          console.log(e);
        },
        function (e) {
          alert("Impossivel copiar!");
          console.log(e);
        }
      );
    },
  },
  mounted() {
    var dataAtual = new Date();
    this.filtroData.dia = dataAtual.getDate();
    this.filtroData.mes = dataAtual.getMonth() + 1;
    this.filtroData.ano = dataAtual.getFullYear();
  },
  data: function () {
    return {
      filtroTexto: "",
      //filtroUsuario: "",
      filtroTipo: "TODOS",
      filtroStatus: "NOVO",
      filtroData: { dia: 0, mes: 0, ano: 0 },
      filtroSite: "Todos",
      //ordem:"vencimento_ASC",
      item: { plano: "" },
      itens: [],
      planos: [],
      headerSites: {},
      itensTotal: 0,
      editItem: null,
      timerFiltroUsuario: null,
    };
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}

.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}

.inputPesquisa {
  max-width: 50%;
}

.botaoNovo {
  margin-top: 6px;
}
</style>
